
import React, {useEffect, useState} from 'react';
import {TableColumn} from 'react-data-table-component';
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Button} from 'react-bootstrap';
import {toast} from 'react-toastify';
import DialogBox from '../../../components/DialogBox';
import { NaturalezaFacturaApi } from '@app/api/estadisticas/NaturalezaFacturaApi';
import NaturalezaFacturaTable from './NaturalezaFacturaTable';

interface NaturalezaFactura {
  idnaturalezafactura: number;
  codigo: string;
  nombre:string;
}

const NaturalezaFactura: React.FC = () => {
  const [data, setData] = useState<NaturalezaFactura[]>([]);
  const [editingData, setEditingData] = useState<NaturalezaFactura | null>(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [inputValue, setInputValue] = useState('');
  const handleChange = (event: { target: { value: any; }; }) => {
    const { value } = event.target;
    if (value.length <= 2) {
      setInputValue(value);
    }else {
      toast.error('El código debe tener solo dos caracteres');
    }
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const handleCloseGuardar = () => {
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    handleReset();
  };

  const handleReset = () => {
    setEditingData(null);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await NaturalezaFacturaApi.getNaturalezaFactura();
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error al obtener los datos:', error);
    }
  };

  const handleEdit = (row: NaturalezaFactura) => {
    console.log('Editar:', row);
    setEditingData(row);
    handleOpen();
  };

  const handleDelete = (row: NaturalezaFactura) => {
    console.log('Eliminar:', row);
    confirmAlert({
      title: 'Confirmar eliminación',
      message: `¿Estás seguro que deseas eliminar el registro ${row.nombre}?`,
      buttons: [
        {
          label: 'Sí',
          onClick: () => {
            const newData = data.filter(
              (d: NaturalezaFactura) => d.idnaturalezafactura !== row.idnaturalezafactura
            );
            setData(newData);
          }
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  const handleSave = (row: NaturalezaFactura) => {
    var validacionDatos = '';
    if (row.idnaturalezafactura) {
      if (row.nombre.length === 0) {
        validacionDatos = 'Nombre no puede estar en blanco';
      }
      const actualizacion = data.find((element) => {
        if (
          element.nombre.toUpperCase() === row.nombre.toUpperCase() &&
          element.idnaturalezafactura !== row.idnaturalezafactura
        ) {
          validacionDatos = 'Error Datos Duplicado, Valide el Catalogo';
          return true;
        }
      });
      if (validacionDatos.length === 0) {
        NaturalezaFacturaApi.updateNaturalezaFactura(row.idnaturalezafactura, row)
          .then(() => {
            setData((prevRow) =>
              prevRow.map((u) =>
                u.idnaturalezafactura === row.idnaturalezafactura ? row : u
              )
            );
            toast.success('Actualización Exitosa');
            handleReset();
            handleCloseGuardar();
          })
          .catch((err) => {
            toast.error('Error de Comunicación, Contacte a TI');
          });
      } else {
        toast.error(validacionDatos);
      }
    } else {
      if (row.nombre.length === 0) {
        validacionDatos = 'Nombre no puede estar en blanco';
      }
      const creacion = data.find((element) => {
        if (element.nombre.toUpperCase() == row.nombre.toUpperCase()) {
          validacionDatos = 'Error Datos Duplicado, Valide el Catalogo';
          return true;
        }
      });
      if (validacionDatos.length === 0) {
        NaturalezaFacturaApi.createNaturalezaFactura(row)
          .then((response) => {
            setData((prevData) => [...prevData, response.data]);
            toast.success('Creación Exitosa');
            handleReset();
            handleCloseGuardar();
          })
          .catch((err) => {
            toast.error('Error de Comunicación, Contacte a TI');
          });
      } else {
        toast.error(validacionDatos);
      }
    }
  };

  const columns: TableColumn<NaturalezaFactura>[] = [
    {name: 'Nombre', selector: (row) => row.nombre},
    {name: 'Código', selector: (row) => row.codigo},
    {
      name: 'Acciones',
      cell: (row: NaturalezaFactura) => (
        <div>
          <button
            onClick={() => handleEdit(row)}
            className="btn btn-primary btn-sm"
          >
            <i className="fa fa-pen"></i> Editar{' '}
          </button>
          &nbsp;
          <button
            onClick={() => handleDelete(row)}
            className="btn btn-danger btn-sm"
          >
            <i className="fa fa-eraser"></i> Eliminar{' '}
          </button>
        </div>
      )
    }
  ];

  return (
    <div>
      <Button variant="success" onClick={handleOpen}>
        <i className="fa fa-plus"></i> Agregar{' '}
      </Button>
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <NaturalezaFacturaTable
          data={data}
          columns={columns}
          customStyles={customStyles}
        />
      )}
      <DialogBox
        open={open}
        onClose={handleClose}
        title={editingData ? 'Editar' : 'Agregar'}
        content={
          <form
            onSubmit={(event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const row: NaturalezaFactura = {
                idnaturalezafactura: editingData?.idnaturalezafactura || 0,
                codigo: formData.get('codigo') as string,
                nombre:formData.get('nombre') as string,
              };
              handleSave(row);
            }}
          >
            <div className="form-group" id="codigo">
              <label>Código</label>
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text"><i className="fa fa-barcode"></i></span>
                </div>
                <input
                  type="text"
                  name="codigo"
                  className="form-control "
                  defaultValue={editingData?.codigo}
                  placeholder="Ingrese el código"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-group" id="nombre">
              <label>Nombre</label>
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">Nombre</span>
                </div>
                <input
                  type="text"
                  name="nombre"
                  className="form-control "
                  defaultValue={editingData?.nombre}
                  placeholder="Ingrese la naturaleza"
                />
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <Button
                type="button"
                className="btn btn-danger"
                onClick={handleClose}
              >
                Cerrar
              </Button>
              <Button type="submit" className="btn btn-success">
                {editingData ? 'Guardar' : 'Agregar'}
              </Button>
            </div>
          </form>
        }
      />
    </div>
  );
};

const customStyles = {
  headCells: {
    style: {
      fontSize: '18px',
      fontWeight: 'bold',
      fontFamily: 'Arial'
    }
  },
  rows: {
    style: {
      fontSize: '18px'
    }
  },
  cells: {
    style: {
      fontSize: '16px'
    }
  },
  pagination: {
    style: {
      fontSize: '14px'
    }
  }
};

export default NaturalezaFactura;